import { SegmentedControl } from "@/components/ui/segmented-control";
import { useDeskAppearance } from "./AppearanceProvider";
import {
  DESK_APPEARANCE_HINTS,
  DESK_APPEARANCE_LABELS,
  DESK_APPEARANCE_SWITCH_ORDER,
  type DeskAppearance,
} from "./appearance";

const APPEARANCE_OPTIONS = DESK_APPEARANCE_SWITCH_ORDER.map((value) => ({
  value,
  label: DESK_APPEARANCE_LABELS[value],
  description: DESK_APPEARANCE_HINTS[value],
}));

/** Appearance pack switcher — embed in account menu (plan/36). */
export function DeskLookSection() {
  const { appearance, setAppearance } = useDeskAppearance();

  return (
    <div className="space-y-1.5 px-1 pb-1">
      <p className="m-0 text-xs font-medium text-[var(--color-muted)]">Look</p>
      <SegmentedControl
        label="Appearance"
        value={appearance}
        options={APPEARANCE_OPTIONS}
        onChange={(next: DeskAppearance) => setAppearance(next)}
      />
      <p className="m-0 text-[0.7rem] leading-snug text-[var(--color-muted-fg)]">
        {DESK_APPEARANCE_HINTS[appearance]}
      </p>
    </div>
  );
}
